import * as React from 'react';
import CardForm from '../../CardForm';
import PaymentCard from './PaymentCard';
import { UilCreditCard, UilInvoice } from '@iconscout/react-unicons';
import { TENANT_LEVEL } from '@nexxt/common/types';
import { getTenantLevel } from '@nexxt/common/firebase/auth/userDetails';
interface PaymentOptionProps {
    billing_info: {
        fullName: string;
        postalCode: string;
        country: string;
    };
    billing_info_error: any;
    errorShow: boolean;
    processing: boolean;
    selectedCard: any;
    paymentIntentSucceeded: boolean;
    paymentRequired: boolean;
    onReset: () => void;
    onSelectCard: (card: any) => void;
    onChangeInfo: (keyName: string, value: any) => void;
    onCardChange: (evt: any) => void;
    handleSubmit: () => Promise<void>;
}
export enum PAYMENT_TYPES {
    INVOICE = 'INVOICE',
    CREDIT_CARD = 'CREDIT_CARD'
}

const PAYMENT_OPTIONS = [
    {
        type: PAYMENT_TYPES.INVOICE,
        label: 'Invoice',
        icon: <UilInvoice size={20} />,
        availableTenantLevels: [
            TENANT_LEVEL.SELF_SERVICE,
            TENANT_LEVEL.FULL_SERVICE
        ]
    },
    {
        type: PAYMENT_TYPES.CREDIT_CARD,
        label: 'Pay with credit card',
        icon: <UilCreditCard size={20} />,
        availableTenantLevels: []
    }
];

const PaymentOption: React.FunctionComponent<PaymentOptionProps> = (
    props: PaymentOptionProps
) => {
    const tenantLevel = getTenantLevel();
    const filteredPaymentOptions = PAYMENT_OPTIONS.filter((opt) =>
        opt.availableTenantLevels.includes(tenantLevel)
    );
    const showCreditCardForm =
        props?.selectedCard?.type === PAYMENT_TYPES.CREDIT_CARD;
    return (
        <>
            <p>
                Please select the option below to confirm your payment method:
            </p>
            <div className="checkout--container--column-body--block">
                <div className="payment-card-list">
                    {filteredPaymentOptions.map((card, index) => (
                        <PaymentCard
                            key={index}
                            card={card}
                            onSelectCard={() => props.onSelectCard(card)}
                            selectedCard={props.selectedCard}
                        />
                    ))}
                </div>
            </div>
            {showCreditCardForm && <CardForm {...props} />}
        </>
    );
};

export default PaymentOption;
